'use strict';

var _ = require('lodash');
var CHARS_TO_ADD = '...';
var NUM_OF_CHARS_TO_KEEP = 3;
var BG_VIDEO_DEFAULTS = {
  opacity: 1,
  autoplay: true,
  loop: true,
  preload: 'auto',
  mute: true
};
var MEDIA_PLAYER_DEFAULTS = {
  opacity: 1,
  autoplay: false,
  loop: false,
  preload: 'none',
  mute: false
};
var TITLE_LENGTH_LIMIT = 100;

function url2uri(url) {
  return url.replace(/^(.*[\/])/, '');
}

function getIdFromUrl(fileUrl) {
  var result = fileUrl.match(/(?:\/|^)([0-9a-fA-F_]+)(?:\/|$)/);
  return result.length > 1 ? result[1] : '';
}

function fixMediaTitleLength(value, lengthLimit) {
  if (value.length <= lengthLimit) {
    return value;
  }
  var arr = value.split('');
  var numOfCharsToRemove = value.length - lengthLimit + CHARS_TO_ADD.length;
  var isFileTypeSuffix = value.lastIndexOf('.') > value.length - numOfCharsToRemove - NUM_OF_CHARS_TO_KEEP;
  var fileTypeSuffixIndex = isFileTypeSuffix ? value.lastIndexOf('.') : value.length - 1;
  var removeIndex = fileTypeSuffixIndex - numOfCharsToRemove - NUM_OF_CHARS_TO_KEEP;
  arr.splice(removeIndex, numOfCharsToRemove, CHARS_TO_ADD);
  return arr.join('');
}

/**
 * extracts the generated images from the video payload
 * @param fileInfo
 * @returns {[string]} images uri
 */
function parseVideoPosters(fileInfo) {
  var fileOutput = fileInfo.fileOutput || fileInfo.file_output;
  return _.map(fileOutput.image, function (image) {
    return url2uri(image.url);
  });
}

/**
 * extracts the video qualities from the video payload
 * @param fileInfo
 * @returns {[{width: number, height: number, quality: string, url: string} || {}]} qualities array
 */
function parseVideoQualities(fileInfo) {
  var fileOutput = fileInfo.fileOutput || fileInfo.file_output;
  var mp4Videos = _.filter(fileOutput.video, { format: 'mp4' });
  var storyboard = _.head(_.get(fileOutput, 'storyboard'));
  var qualities = _.map(mp4Videos, function (quality) {
    return _.pick(quality, ['width', 'height', 'quality', 'url']);
  });

  if (storyboard) {
    qualities.push({
      quality: 'storyboard',
      width: storyboard.width,
      height: storyboard.height,
      url: storyboard.url
    });
  }

  return qualities;
}

/**
 * extracts the video adaptive formats and url from the video payload
 * @param fileInfo
 * @returns {[{format: string, url: string}] || []} qualities array
 */
function parseAdaptiveUrls(fileInfo) {
  var fileOutput = fileInfo.fileOutput || fileInfo.file_output;
  var adaptiveVideo = fileOutput.adaptiveVideo || fileOutput.adaptive_video;
  return _.map(adaptiveVideo, function (item) {
    return {
      format: item.format,
      url: item.url
    };
  });
}

/**
 * parse media manager video file response into WixVideo object scheme
 * @param fileInfo - media manager, video file object response (https://docs.google.com/a/wix.com/document/d/1_fqnV0JcTfMHVpqKJIR9jFV-l6YGxv8_7cc3XQ7I2OY)
 * @param info - media manager, folder information
 * @returns {{type: string, title: *, videoId: string, duration: number, posterImageRef: *, generatedPosters: string[], qualities: ({width: number, height: number, quality: string, url: string}|{})[], artist: {name: (*|string), id: (*|string)}, hasAudio: boolean, fps: (string|*)}}
 * https://docs.google.com/a/wix.com/document/d/1BcbazImlny7Y5k4dE5B6n-FD4_NkXAeluefsl8324Js
 */
function parseVideoFileInfo(fileInfo, info) {
  var fileInput = fileInfo.fileInput || fileInfo.file_input;
  var fileOutput = fileInfo.fileOutput || fileInfo.file_output;
  var videoId = getIdFromUrl(fileInfo.fileUrl || fileInfo.file_name);
  var title = fixMediaTitleLength(fileInfo.title, TITLE_LENGTH_LIMIT);
  var qualities = parseVideoQualities(fileInfo);
  var adaptiveVideo = parseAdaptiveUrls(fileInfo);
  // parse poster - get the first item in data
  var imageData = _.head(fileOutput.image);
  var posterImageRef = {
    type: 'Image',
    width: imageData.width,
    height: imageData.height,
    uri: url2uri(imageData.url),
    description: info.path ? info.path : undefined
  };

  return {
    type: 'WixVideo',
    title: title,
    videoId: videoId,
    duration: +(fileInput.duration / 1000).toFixed(2),
    posterImageRef: posterImageRef,
    generatedPosters: parseVideoPosters(fileInfo),
    qualities: qualities,
    adaptiveVideo: adaptiveVideo,
    artist: { name: fileInfo.vendor || '', id: fileInfo.reference || '' },
    hasAudio: _.head(fileOutput.video).audio_bitrate !== -1,
    fps: _.get(_.head(fileOutput.video), 'fps', '').toString()
  };
}

function getVideoBackgroundObject(fileInfo, info) {
  var mediaObject = parseVideoFileInfo(fileInfo, info);
  return _.assign(mediaObject, BG_VIDEO_DEFAULTS);
}

function getMediaPlayerVideoObject(fileInfo, info) {
  var mediaObject = parseVideoFileInfo(fileInfo, info);
  return _.assign(mediaObject, MEDIA_PLAYER_DEFAULTS);
}

function getVideoPosterObject(videoId, uri, width, height) {
  return {
    type: 'WixVideo',
    videoId: videoId,
    posterImageRef: {
      type: 'Image',
      uri: uri,
      width: width,
      height: height
    }
  };
}

/**
 *
 * @param fileInfo
 * @param info - media manager, folder information
 * @returns {{uri: *, title: *, width: *, height: *}}
 */
function getImageBackgroundObject(fileInfo, info) {
  return {
    type: 'Image',
    uri: fileInfo.fileName,
    title: fixMediaTitleLength(fileInfo.title, TITLE_LENGTH_LIMIT),
    description: info.path,
    width: fileInfo.width,
    height: fileInfo.height,
    artist: { name: fileInfo.vendor || '', id: fileInfo.reference || '' }
  };
}

module.exports = {
  getVideoBackgroundObject: getVideoBackgroundObject,
  getVideoPosterObject: getVideoPosterObject,
  getMediaPlayerVideoObject: getMediaPlayerVideoObject,
  getImageBackgroundObject: getImageBackgroundObject,
  fixMediaTitleLength: fixMediaTitleLength
};


// WEBPACK FOOTER //
// ./~/santa-platform-utils/lib/backgroundUtils.js